import { render, staticRenderFns } from "./AboutAccount.vue?vue&type=template&id=40665671&scoped=true&"
import script from "./AboutAccount.vue?vue&type=script&lang=js&"
export * from "./AboutAccount.vue?vue&type=script&lang=js&"
import style0 from "./AboutAccount.vue?vue&type=style&index=0&id=40665671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40665671",
  null
  
)

export default component.exports